/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CreateNotificationRequestBody,
  CreateNotificationRequestBodyToJSON,
  CreateNotificationResponseBody,
  CreateNotificationResponseBodyFromJSON,
  EditNotificationRequestBody,
  EditNotificationRequestBodyToJSON,
  FetchNotificationResponse,
  FetchNotificationResponseFromJSON,
  FetchNotificationsResponse,
  FetchNotificationsResponseFromJSON,
  FetchUserNotificationsResponse,
  FetchUserNotificationsResponseFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface CreateNotificationRequest
  extends runtime.BaseRequestParameters {
  body: CreateNotificationRequestBody
}

export interface DeleteNotificationRequest
  extends runtime.BaseRequestParameters {
  notificationKey: number
}

export interface EditNotificationRequest extends runtime.BaseRequestParameters {
  body: EditNotificationRequestBody
}

export interface FetchNotificationRequest
  extends runtime.BaseRequestParameters {
  notificationKey: number
}

export interface FetchNotificationsRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  search?: string
}

export interface FetchUserNotificationsRequest
  extends runtime.BaseRequestParameters {}

/**
 * NotificationsApi - interface
 *
 * @export
 * @interface NotificationsApiInterface
 */
export interface NotificationsApiInterface {
  /**
   *
   * @summary Creates a notification to be shown on certain users screens pertaining to system updates and notices.
   * @param {CreateNotificationRequestBody} createNotificationRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApiInterface
   */
  createNotificationRaw(
    requestParameters: CreateNotificationRequest
  ): Promise<runtime.ApiResponse<CreateNotificationResponseBody>>

  /**
   * Creates a notification to be shown on certain users screens pertaining to system updates and notices.
   */
  createNotification(
    requestParameters: CreateNotificationRequest
  ): Promise<CreateNotificationResponseBody>

  /**
   *
   * @summary Takes a notificationKey as a url param and deletes it and the associated notification roles/regions.
   * @param {number} notificationKey The key of the notification to edit.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApiInterface
   */
  deleteNotificationRaw(
    requestParameters: DeleteNotificationRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Takes a notificationKey as a url param and deletes it and the associated notification roles/regions.
   */
  deleteNotification(
    requestParameters: DeleteNotificationRequest
  ): Promise<void>

  /**
   *
   * @summary Edits an existing notification to be shown on certain users screens pertaining to system updates and notices.
   * @param {EditNotificationRequestBody} editNotificationRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApiInterface
   */
  editNotificationRaw(
    requestParameters: EditNotificationRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Edits an existing notification to be shown on certain users screens pertaining to system updates and notices.
   */
  editNotification(requestParameters: EditNotificationRequest): Promise<void>

  /**
   *
   * @summary Fetches a single notification and all relations for an admin to view or edit.
   * @param {number} notificationKey The key of the notification to edit.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApiInterface
   */
  fetchNotificationRaw(
    requestParameters: FetchNotificationRequest
  ): Promise<runtime.ApiResponse<FetchNotificationResponse>>

  /**
   * Fetches a single notification and all relations for an admin to view or edit.
   */
  fetchNotification(
    requestParameters: FetchNotificationRequest
  ): Promise<FetchNotificationResponse>

  /**
   *
   * @summary Fetches the list of notifications for admins to edit.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {string} [search] Search for notifications by the name of the notification. Must be at least 3 characters in length.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApiInterface
   */
  fetchNotificationsRaw(
    requestParameters: FetchNotificationsRequest
  ): Promise<runtime.ApiResponse<FetchNotificationsResponse>>

  /**
   * Fetches the list of notifications for admins to edit.
   */
  fetchNotifications(
    requestParameters: FetchNotificationsRequest
  ): Promise<FetchNotificationsResponse>

  /**
   *
   * @summary Fetches notifications to display to the user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApiInterface
   */
  fetchUserNotificationsRaw(
    requestParameters: FetchUserNotificationsRequest
  ): Promise<runtime.ApiResponse<FetchUserNotificationsResponse>>

  /**
   * Fetches notifications to display to the user.
   */
  fetchUserNotifications(): Promise<FetchUserNotificationsResponse>
}

/**
 *
 */
export class NotificationsApi
  extends runtime.BaseAPI
  implements NotificationsApiInterface
{
  /**
   * Creates a notification to be shown on certain users screens pertaining to system updates and notices.
   */
  async createNotificationRaw(
    requestParameters: CreateNotificationRequest
  ): Promise<runtime.ApiResponse<CreateNotificationResponseBody>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createNotification.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/admin/notifications`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: CreateNotificationRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateNotificationResponseBodyFromJSON(jsonValue)
    )
  }

  /**
   * Creates a notification to be shown on certain users screens pertaining to system updates and notices.
   */
  async createNotification(
    requestParameters: CreateNotificationRequest
  ): Promise<CreateNotificationResponseBody> {
    const response = await this.createNotificationRaw(requestParameters)
    return await response.value()
  }

  /**
   * Takes a notificationKey as a url param and deletes it and the associated notification roles/regions.
   */
  async deleteNotificationRaw(
    requestParameters: DeleteNotificationRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.notificationKey === null ||
      requestParameters.notificationKey === undefined
    ) {
      throw new runtime.RequiredError(
        'notificationKey',
        'Required parameter requestParameters.notificationKey was null or undefined when calling deleteNotification.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/admin/notifications/{notificationKey}`.replace(
        `{${'notificationKey'}}`,
        encodeURIComponent(String(requestParameters.notificationKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Takes a notificationKey as a url param and deletes it and the associated notification roles/regions.
   */
  async deleteNotification(
    requestParameters: DeleteNotificationRequest
  ): Promise<void> {
    await this.deleteNotificationRaw(requestParameters)
  }

  /**
   * Edits an existing notification to be shown on certain users screens pertaining to system updates and notices.
   */
  async editNotificationRaw(
    requestParameters: EditNotificationRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling editNotification.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/admin/notifications`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: EditNotificationRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Edits an existing notification to be shown on certain users screens pertaining to system updates and notices.
   */
  async editNotification(
    requestParameters: EditNotificationRequest
  ): Promise<void> {
    await this.editNotificationRaw(requestParameters)
  }

  /**
   * Fetches a single notification and all relations for an admin to view or edit.
   */
  async fetchNotificationRaw(
    requestParameters: FetchNotificationRequest
  ): Promise<runtime.ApiResponse<FetchNotificationResponse>> {
    if (
      requestParameters.notificationKey === null ||
      requestParameters.notificationKey === undefined
    ) {
      throw new runtime.RequiredError(
        'notificationKey',
        'Required parameter requestParameters.notificationKey was null or undefined when calling fetchNotification.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/admin/notifications/{notificationKey}`.replace(
        `{${'notificationKey'}}`,
        encodeURIComponent(String(requestParameters.notificationKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchNotificationResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetches a single notification and all relations for an admin to view or edit.
   */
  async fetchNotification(
    requestParameters: FetchNotificationRequest
  ): Promise<FetchNotificationResponse> {
    const response = await this.fetchNotificationRaw(requestParameters)
    return await response.value()
  }

  /**
   * Fetches the list of notifications for admins to edit.
   */
  async fetchNotificationsRaw(
    requestParameters: FetchNotificationsRequest
  ): Promise<runtime.ApiResponse<FetchNotificationsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/admin/notifications`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchNotificationsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetches the list of notifications for admins to edit.
   */
  async fetchNotifications(
    requestParameters?: FetchNotificationsRequest
  ): Promise<FetchNotificationsResponse> {
    const response = await this.fetchNotificationsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Fetches notifications to display to the user.
   */
  async fetchUserNotificationsRaw(
    requestParameters: FetchUserNotificationsRequest
  ): Promise<runtime.ApiResponse<FetchUserNotificationsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/notifications`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchUserNotificationsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetches notifications to display to the user.
   */
  async fetchUserNotifications(
    requestParameters?: FetchUserNotificationsRequest
  ): Promise<FetchUserNotificationsResponse> {
    const response = await this.fetchUserNotificationsRaw(
      requestParameters || {}
    )
    return await response.value()
  }
}
